<template>
    <div
        v-if="isLoadedState"
        class="t-user">
        <div class="row">
            <div class="col">
                <div :class="{ 'u-loader' : inProgressSchedule }">
                    <div :class="{ 'invisible' : inProgressSchedule }">
                        <ul class="c-color-list-reservation">
                            <li class="mr-1"><span></span>予約不可</li>
                            <li><span></span>予約可能</li>
                        </ul>
                        <div
                            id="reservation-calendar-wrapper"
                            class="c-fullcalendar-reservation">
                            <FullCalendar
                                id="calendar-from-doctor"
                                class="calendar-wrapper"
                                ref="fullCalendar"
                                :plugins="calendarPlugins"
                                :default-view="config.defaultView"
                                :header="config.header"
                                :height="config.height"
                                :locale="config.locale"
                                :events="events"
                                :event-text-color="config.eventTextColor"
                                :valid-range="config.validRange"
                                :show-non-current-dates="config.showNonCurrentDates"
                                :event-time-format="config.eventTimeFormat"
                                :default-date="helper.userTimeNow(user.timezone).format('YYYY-MM-DD HH:mm:ss')"
                                @dateClick="dateClick"
                                :dates-render="datesRender">
                            </FullCalendar>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a id="linkReservationSelectTimeWrapper" class="invisible" href="#reservationSelectTimeWrapper"></a>
        <div id="reservationSelectTimeWrapper">
            <div
                v-show="selectedDate !== null"
                class="row">
                <div class="col">
                    <div
                        v-if="inProgress"
                        class="reservationSelectTimeSpinner d-flex justify-content-center align-items-center">
                        <b-spinner variant="yokumiru-user"/>
                    </div>
                    <div
                        class="reservationFromDoctorTimesWrapper"
                        :class="{ 'd-flex justify-content-center align-items-center' : !hasSchedules }">
                        <template v-if="hasSchedules">
                            <div class="reservationFromDoctorTimes d-flex flex-wrap">
                                <div
                                    v-for="schedule in schedules"
                                    class="reservationFromDoctorSelectTimeButtonWrapper">
                                    <div
                                        v-if="
                                        $store.state.reservation.schedule &&
                                        $store.state.reservation.schedule.start_time === schedule.start_time"
                                        class="reservationFromDoctorSelectTimeButton selected btn btn-sm d-flex justify-content-center"
                                        @click="onSelectScheduleTime(schedule)">
                                        {{ helper.displayStartTimeNoConvert(schedule.start_time) }}
                                    </div>
                                    <div
                                        v-else
                                        class="reservationFromDoctorSelectTimeButton btn btn-sm d-flex justify-content-center"
                                        @click="onSelectScheduleTime(schedule)">
                                        {{ helper.displayStartTimeNoConvert(schedule.start_time) }}
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="!inProgress">
                            <div class="text-muted text-center">
                                <div>申し訳ございません。予約可能な時間が見つかりませんでした。</div>
                                <template v-if="$store.state.reservation.searchDate !== null">
                                    <div>検索された日付はすでに予約で埋まっている可能性がございます。</div>
                                    <b-button
                                        variant="yokumiru-gray mt-3"
                                        @click="close">
                                        日付を再検索する
                                    </b-button>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'
    import constants from '../../constants'
    import YokumiruHelper from '../../YokumiruHelper'
    import moment from 'moment-timezone'

    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import interactionPlugin from '@fullcalendar/interaction'
    import ja from '@fullcalendar/core/locales/ja'
    import '@fullcalendar/core/main.css'
    import '@fullcalendar/daygrid/main.css'

    export default {
        components: {
            FullCalendar,
        },

        data: function () {
            return {
                calendarPlugins: [dayGridPlugin, interactionPlugin],
                helper: YokumiruHelper,
                mode: null,
                user: null,
                doctor: null,
                medicalCourse: null,
                doctorMenu: null,
                selectedDate: null,
                schedules: [],
                css: {},
                inProgress: false,
                inProgressSchedule: true,
                isSetDefaultDate: false,
                isAttemptedToSetDefaultDate: false,
                config: {
                    locale: ja,
                    header: {
                        left: 'prev',
                        center: 'title',
                        right: 'next',
                    },
                    defaultView: 'dayGridMonth',
                    eventTextColor: '#fff',
                    dateFormat: 'dd',
                    views: {
                        dayGridMonth: {
                            columnFormat: 'ddd',
                        },
                        dayGridWeek: {
                            columnFormat: 'D（ddd）',
                        },
                        timeGridWeek: {
                            columnFormat: 'D（ddd）',
                        },
                    },
                    titleFormat: 'Y年M月',
                    slotLabelFormat: 'HH:mm',
                    displayEventEnd: false,
                    editable: false,
                    height: 'auto',
                    showNonCurrentDates: false,
                    eventTimeFormat: {
                        hour: '2-digit',
                        minute: '2-digit',
                    },
                    validRange: {
                        start: moment().startOf('month').format('YYYY-MM-DD'),
                        end: null,
                    },
                },
                events: [],
                currentYear: null,
                currentMonth: null,
            }
        },

        computed: {
            isLoadedState: function () {
                if (this.mode === 'default') {
                    return this.user !== null
                        && this.medicalCourse !== null
                        && this.doctor !== null
                        && this.doctorMenu !== null
                        // && this.isAutoReserved !== null
                }
                else if (this.mode === 'matching') {
                    return this.user !== null
                        && this.medicalCourse !== null
                        // && this.isAutoReserved !== null
                }
                // else if (this.mode === 'auto') {
                //     return this.user !== null
                //         && this.medicalCourse !== null
                //         && this.isAutoReserved !== null
                // }

                return false
            },

            /**
             * 予約可能日数
             * @return {number}
             */
            allowDays: function () {
                if (this.helper.hasSubscriptionPeriodEnd(this.user)) {
                    return this.helper.subscriptionDiffDays(this.user, true)
                }
                return this.$store.state.configs.reservation_allow_days
            },

            /**
             * スケジュール存在判定
             *
             * @return {bool}
             */
            hasSchedules: function () {
                return this.schedules && this.schedules.length > 0
            },
        },

        created: function () {
            this.init()
            bus.$on('start-reservation-from-doctor', this.init)
            bus.$on('render-calendar-from-doctor', this.bindSchedules)
            bus.$on('analytics-schedule-selected', this.pushAnalyticsDataLayer)
        },

        beforeDestroy: function () {
            bus.$off('start-reservation-from-doctor')
            bus.$off('render-calendar-from-doctor')
            bus.$off('analytics-schedule-selected')
        },

        methods: {
            ...mapMutations({
                setSchedule: 'reservation/setSchedule',
                setDoctorMenu: 'reservation/setDoctorMenu',
            }),

            /**
             * [FullCalendar]
             * レンダリング完了時
             *
             * @see https://fullcalendar.io/docs/datesRender
             */
            datesRender: function ({view}) {
                const date = this.$refs.fullCalendar.getApi().getDate()
                bus.$emit('render-calendar-from-doctor', date.getFullYear(), date.getMonth())
            },

            /**
             * 初期化処理
             */
            init: async function () {
                this.isSetDefaultDate = false

                this.mode = this.$store.state.reservation.mode
                this.user = this.$store.state.reservation.user
                this.medicalCourse = this.$store.state.reservation.medicalCourse
                // this.isAutoReserved = this.$store.state.reservation.isAutoReserved

                if (this.mode === 'default') {
                    this.doctor = this.$store.state.reservation.doctorMenu.doctor
                    this.doctorMenu = this.$store.state.reservation.doctorMenu
                }

                this.paintClear()

                // 相談予約可能範囲の設定（validRange.endは何故か範囲に含まれないため+1dayしている）
                this.config.validRange.end = this.helper.userTimeNow(this.user.timezone)
                    .add(this.allowDays, 'days')
                    .endOf('month')
                    .add(1, 'days')
                    .format('YYYY-MM-DD')

                // 2回目以降の表示時
                if (this.currentYear !== null && this.currentMonth !== null) {
                    this.bindSchedules(this.currentYear, this.currentMonth)
                }

                this.schedules = []
                this.selectedDate = null
            },

            /**
             * スケジュール取得APIリクエスト用のクエリを生成
             *
             * @param {moment} start
             * @param {moment} end
             * @returns {string}
             */
            scheduleQuery: function (start, end) {
                let query = `?medical_course_id=${this.medicalCourse.id}`
                query += `&start_date=${start.format('YYYY-MM-DD')}&end_date=${end.format('YYYY-MM-DD')}`

                if (this.mode === 'default') {
                    query += `&doctor_menu_id=${this.doctorMenu.id}`
                }

                return query
            },

            /**
             * 日付ごとにスケジュールを入れる
             * 空きスケジュールの数によってカレンダー背景色を設定
             *
             * @param {number|null} year
             * @param {number|null} month
             */
            bindSchedules: async function (year, month) {
                if (!this.medicalCourse) return
                this.inProgressSchedule = true

                // 日時の選択状態をリセット
                this.isSetDefaultDate = false
                this.schedules = []
                this.selectedDate = null
                this.setSchedule(null)

                if (Number.isInteger(year)) {
                    this.currentYear = year
                }
                if (Number.isInteger(month)) {
                    this.currentMonth = month
                }

                const start = moment().year(this.currentYear).month(this.currentMonth).startOf('month').subtract(1, 'days')
                const end = moment().year(this.currentYear).month(this.currentMonth).endOf('month').add(1, 'days')

                const endpoint = constants.user.schedules.endpoint.base
                const query = this.scheduleQuery(start, end)

                await axios.get(`${endpoint}${query}`)
                    .then( ({data}) => {
                        const schedules = this.convertSchedulesFromJST(data.data, start, end, this.user.timezone)

                        while (start.diff(end) <= 0) {
                            const date = start.format('YYYY-MM-DD')

                            if (!schedules[date]) {
                                start.add(1, 'days')
                                continue
                            }
                            this.css[date] = schedules[date].count > 0 ? `date-available,${schedules[date].count}` : 'date-disabled,0'

                            if (!this.isSetDefaultDate) {
                                let shouldSelectDefault = false

                                if (this.$store.state.reservation.searchDate) {
                                    shouldSelectDefault = this.$store.state.reservation.searchDate === date
                                }
                                else if (schedules[date].count > 0) {
                                    shouldSelectDefault = true
                                }

                                if (shouldSelectDefault) {
                                    this.selectedDate = moment(`${date} 00:00:00`)

                                    // カレンダーの表示月と同じ場合のみ日付をデフォルト選択する
                                    if (this.selectedDate.month() === this.currentMonth) {
                                        this.isSetDefaultDate = true
                                        this.fetchSchedules(this.selectedDate)
                                        $('#reservation-calendar-wrapper td.fc-day-top').each(function () {
                                            if (this.dataset.date === start.format('YYYY-MM-DD')) {
                                                this.children[0].classList.add('current-date')
                                            }
                                        })
                                    }
                                }
                            }
                            start.add(1, 'days')
                        }
                    } )

                // カレンダーの表示月に1件もスケジュールが存在せず、日付がデフォルト選択されなかった場合は翌月を表示
                // （翌月もスケジュールが存在しなかった場合はそこで打ち止め）
                if (!this.isSetDefaultDate && !this.isAttemptedToSetDefaultDate) {
                    this.isAttemptedToSetDefaultDate = true
                    this.inProgressSchedule = false
                    this.$refs.fullCalendar.getApi().next()
                }
                else {
                    //「◯日」の「日」を削除
                    $('#reservation-calendar-wrapper span.fc-day-number').each(function () {
                        if (this.innerText.includes('日')) {
                            this.innerText = this.innerText.slice(0, -1)
                        }
                        else if (this.innerHTML.includes('日')) {
                            this.innerHTML = this.innerHTML.slice(0, -1)
                        }
                    })
                    this.paint()
                    this.inProgressSchedule = false
                }
            },

            /**
             * JST形式のスケジュールデータをユーザのtimezone基準で変換
             *
             * @params {object} data
             * @params {moment} start
             * @params {moment} end
             * @params {string} timezone
             *
             * @return {object}
             */
            convertSchedulesFromJST: function (data, start, end, timezone) {
                const holder = {}
                const now = this.helper.userTimeNow(timezone)
                start = start.clone()

                while (start.diff(end) <= 0) {
                    const dateFormat = start.format('YYYY-MM-DD')

                    if (data[dateFormat] && data[dateFormat].count > 0) {
                        data[dateFormat].schedules.forEach(schedule => {
                            const st = this.helper.userTime(`${dateFormat} ${schedule.start_time}`, timezone)
                            const edDateFormat = schedule.is_split ? start.clone().add(1, 'days').format('YYYY-MM-DD') : dateFormat
                            const ed = this.helper.userTime(`${edDateFormat} ${schedule.end_time}`, timezone)

                            schedule.start_time = st.format('HH:mm')
                            schedule.end_time = ed.format('HH:mm')

                            // 開始時間が終了時間より小さい場合のみ処理（サマータイム対策）
                            if (st.diff(ed) < 0) {
                                if (this.hasHolder(holder, st, schedule)) {
                                    const result = this.removeHolderItem(holder, st, schedule)
                                    if (result) {
                                        this.prepareHolder(holder, start)
                                        this.prepareHolder(holder, st)
                                        this.pushToHolder(holder, st, now, schedule)
                                    }
                                }
                                else {
                                    this.prepareHolder(holder, start)
                                    this.prepareHolder(holder, st)
                                    this.pushToHolder(holder, st, now, schedule)
                                }
                            }
                        })
                    }
                    else {
                        this.prepareHolder(holder, start)
                    }
                    start.add(1, 'days')
                }

                return holder
            },

            hasHolder: function (holder, date, schedule) {
                if (!holder[date.format('YYYY-MM-DD')]) {
                    return false
                }

                const result = holder[date.format('YYYY-MM-DD')].schedules.find((s) => {
                    return schedule.start_time === s.start_time && schedule.end_time === s.end_time
                })

                return !!result
            },

            /**
             * reservation_allow_before_min が最小のスケジュールを優先するため holder に入れたスケジュールを取り除く
             * @param holder
             * @param date
             * @param schedule
             * @return {boolean}
             */
            removeHolderItem: function (holder, date, schedule) {
                if (!holder[date.format('YYYY-MM-DD')]) {
                    return false
                }

                const idx = holder[date.format('YYYY-MM-DD')].schedules.findIndex((s) => {
                    return schedule.start_time === s.start_time
                        && schedule.end_time === s.end_time
                        && schedule.doctor.reservation_allow_before_min < s.doctor.reservation_allow_before_min
                })

                if (idx === -1) {
                    return false
                }
                holder[date.format('YYYY-MM-DD')].schedules.splice(idx, 1)
                return true
            },

            prepareHolder: function (holder, date) {
                if (!holder[date.format('YYYY-MM-DD')]) {
                    holder[date.format('YYYY-MM-DD')] = {
                        schedules: [],
                        count: 0,
                        day: date.day()
                    }
                }
            },

            pushToHolder: function (holder, date, now, schedule) {
                holder[date.format('YYYY-MM-DD')].schedules.push(schedule)

                if (now.diff(date) < 0) {
                    holder[date.format('YYYY-MM-DD')].count += 1
                }
            },

            /**
             * カレンダー背景色を反映
             */
            paint: function () {
                const $date = document.querySelectorAll(`#calendar-from-doctor td[data-date]`)

                Array.prototype.forEach.call($date, $d => {
                    const $child = $d.querySelector('span')

                    if ($child) {
                        if (this.css[$d.dataset.date]) {
                            const css = this.css[$d.dataset.date].split(',')
                            css.forEach((c) => $child.classList.add(c))
                        }
                    }
                });
            },

            /**
             * カレンダー背景色の解除
             */
            paintClear: function () {
                this.css = {}
                const $date = document.querySelectorAll(`#calendar-from-doctor td[data-date]`)

                Array.prototype.forEach.call($date, $d => {
                    const $child = $d.querySelector('span')

                    if ($child) {
                        $child.classList.remove('date-available')
                        $child.classList.remove('date-disabled')
                        $child.classList.remove('current-date')
                    }
                })
            },

            /**
             * [FullCalendar]
             * 日付クリック時
             */
            dateClick: async function ({dateStr, jsEvent}) {
                if (jsEvent.target.nodeName !== 'SPAN') {
                    jsEvent.preventDefault()
                    return
                }

                // 日時の選択状態をリセット
                this.schedules = []
                this.selectedDate = null
                this.setSchedule(null)

                const clickDate = moment(dateStr.substr(0, 10) + " 00:00:00")
                const userNow = this.helper.userTimeNow(this.user.timezone).startOf('day')
                const diffBefore = clickDate.diff(userNow, 'day', true)

                const limitDays = moment().add(this.$store.state.configs.reservation_allow_days, 'days')
                const diffAfter = clickDate.diff(limitDays, 'day', true)

                if (diffBefore < 0 || diffAfter > 0) {
                    jsEvent.preventDefault()
                    return
                }

                $('#reservation-calendar-wrapper span.fc-day-number').each(function () {
                    this.classList.remove('current-date')
                })
                jsEvent.target.classList.add('current-date')

                this.selectedDate = clickDate
                await this.fetchSchedules(clickDate)

                // 時間選択のUIにジャンプ
                document.getElementById('linkReservationSelectTimeWrapper').click()
            },

            /**
             * スケジュールの取得
             */
            fetchSchedules: async function(date) {
                if (this.inProgress) return
                this.inProgress = true

                this.schedules = []
                const start = date.clone().subtract(1, 'days')
                const end = date.clone().add(1, 'days')

                const endpoint = constants.user.schedules.endpoint.base
                const query = this.scheduleQuery(start, end)

                await axios.get(`${endpoint}${query}`)
                    .then(({data}) => {
                        this.schedules = this.convertSchedulesFromJST(data.data, start, end, this.user.timezone)[date.format('YYYY-MM-DD')].schedules

                        // @todo issue/515 時間選択状態にする場合（仮コードにつき動作未検証）
                        // if (this.$store.state.reservation.searchStartTime !== null) {
                        //     const st = this.$store.state.reservation.searchStartTime
                        //     const schedule = this.schedules.find((s) => s.start_time === st)
                        //     if (schedule && this.selectedDate) {
                        //         schedule.date = this.selectedDate
                        //         this.setSchedule(schedule)
                        //     }
                        // }
                    })

                this.inProgress = false
            },

            /**
             * 時間選択時
             *
             * @param {object} schedule
             */
            onSelectScheduleTime: function (schedule) {
                schedule.date = this.selectedDate
                this.setSchedule(schedule)

                if (this.mode === 'default' || this.mode === 'matching') {
                    this.handleOk()
                }
            },

            handleOk: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const params = {
                    medical_course_id: this.medicalCourse.id,
                    doctor_id: null,
                    doctor_menu_id: null,
                    start_time: this.startDateTime().format('YYYY-MM-DD HH:mm:ss'),
                    end_time: this.endDateTime().format('YYYY-MM-DD HH:mm:ss'),
                    confirm: 1,
                }
                if (this.mode === 'default') {
                    params.doctor_id = this.doctor.id
                    params.doctor_menu_id = this.doctorMenu.id
                }

                await axios.post(constants.user.consultations.endpoint.base, params)
                    .then(({data}) => {
                        if (data.status === 'OK') {
                            this.pushAnalyticsDataLayer(params)
                            bus.$emit('open-modal-reservation-payment-method')
                        }
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors') &&
                            response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            /**
             * GoogleAnalytics GA4 カスタムイベント発火
             *
             * @param {object} params
             */
            pushAnalyticsDataLayer: function (params) {
                if (this.$locale.type !== 'consul') return

                const doctorMenuId = this.doctorMenu ? this.doctorMenu.id : null
                const doctorMenuTitle = this.doctorMenu ? this.doctorMenu.title : null

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__selectScheduleTime',
                    startTime: params.start_time,
                    endTime: params.end_time,
                    doctorMenuId: doctorMenuId,
                    doctorMenuTitle: doctorMenuTitle,
                })
            },

            /**
             * 相談開始日時フォーマット
             *
             * @return {moment}
             */
            startDateTime: function () {
                const schedule = this.$store.state.reservation.schedule
                if (schedule.start_time === '24:00') {
                    schedule.start_time = '00:00'
                }
                const format = schedule.date.format('YYYY-MM-DD')

                return this.helper.jstTime(`${format} ${schedule.start_time}:00`, this.user.timezone)
            },

            /**
             * 相談終了日時フォーマット
             *
             * @return {moment|null}
             */
            endDateTime: function () {
                if (this.mode === 'default') {
                    return this.startDateTime().add(this.doctorMenu.consultation_minutes, 'minutes')
                }
                return this.startDateTime().add(this.medicalCourse.matching_minutes, 'minutes')
            },

            close: function () {
                bus.$emit('close-modal-reservation-doctor-menu-detail')
            },
        },
    }
</script>

<style scoped lang="scss">
#medical_course_id {
    width: 200px;
    height: 40px;
}

#reservationSelectTimeWrapper {
    position: relative;
    margin-bottom: 30px;

    .reservationSelectTimeSpinner {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,0.7)
    }
}

.reservationFromDoctorTimesWrapper {
    width: 474px;
    height: 240px;
    margin: 30px auto 0 auto;
    overflow-y: auto;

    @media screen and (max-width: 767px) {
        width: 100%;
        height: 220px;
        margin-top: 0;
    }

    .reservationFromDoctorTimes {
        .reservationFromDoctorSelectTimeButtonWrapper {
            width: 230px;
            margin: 2px;
            box-sizing: border-box;

            @media screen and (max-width: 767px) {
                width: 100%;
                margin: 2px 0;
            }

            .reservationFromDoctorSelectTimeButton {
                width: 100%;
                padding: 12px 0;
                background: #efc72f;
                transition: background-color 0.2s ease-in-out;

                &:hover {
                    background: #e4b812;
                }

                &.selected {
                    color: #fff;
                    background: #EE7321;
                }
            }
        }
    }
}

.reservationFromDoctorSelectedSchedule {
    visibility: hidden;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: center;

    &.visible {
        visibility: visible;
    }

    span {
        color: #497EAF;
        font-size: 15px;
        font-weight: bold;

        &:nth-child(1) {
            color: #757C83;
            font-size: 14px;
            font-weight: normal;
        }
    }
}
</style>

<style lang="scss">
//
// @see _fullcalendar-extends.scss
//
.c-fullcalendar-reservation {
    .fc {
        .fc-row {
            .fc-content-skeleton {
                .fc-event-container {
                    position: relative;
                    top: -12px;
                }

                td {
                    line-height: 62px;
                }

                @media screen and (max-width: 767px) {
                    td {
                        line-height: 42px;
                    }
                }
            }
        }
    }

    .fc-dayGrid-view {
        .fc-body {
            .fc-row {
                // ウィンドウサイズの変更時にfullcalendarがstyleを動的付与してしまうため !important が必要
                height: 62px !important;
                min-height: 65px !important;

                @media screen and (max-width: 767px) {
                    height: 42px !important;
                    min-height: 45px !important;
                }
            }
        }
    }

    span.current-date {
        color: #fff !important;
        background-color: #ef7320 !important;
    }

    .fc-ltr {
        .fc-dayGridMonth-view {
            .fc-day-top {
                .fc-day-number {
                    display: block;
                    width: 60px;
                    height: 60px;
                    margin: 0 auto;
                    text-align: center;
                    border-radius: 50%;
                    padding: 0;
                    vertical-align: middle;
                    float: none !important;
                    cursor: pointer;
                    transition: background .15s ease-in-out;

                    @media screen and (max-width: 767px) {
                        width: 42px;
                        height: 42px;
                    }
                }
            }
        }
    }
}
</style>
